import { Throwable, ThrowableStatus } from "@wss/error-tracking/throwable";

type MostRecentOrder = {
  orderNumber: number;
  dateOrdered: string;
  orderStatus: string;
  dateShipped: string;
  orderItemCount: number;
};

type StatusBarFlags = {
  orderNumberEncrypted: string;
  showStatusBar: boolean;
  showMostRecentOrder: boolean;
  showAbandonCartMessage: boolean;
};

type NotificationBarData = {
  mostRecentOrder: MostRecentOrder;
  statusBarFlags: StatusBarFlags;
};

export async function fetchNotificationBarData(): Promise<
  ThrowableStatus<NotificationBarData>
> {
  try {
    const url = new URL(`/api/getnotificationbar`, window.location.origin);
    const response = await fetch(url);
    if (response.status === 404) {
      const error = new Error("Error getting NotificationBar data");
      return { isError: true, status: response.status, error };
    }
    const result = await response.json<NotificationBarData>();
    return { isError: false, value: result };
  } catch (error) {
    return {
      isError: true,
      status: null,
      error: new Error(
        "There was an error with the '/api/getnotificationbar' endpoint",
        { cause: error }
      ),
    };
  }
}

type MostRecentMessageResponse = { emailSubject: string };

export async function fetchMostRecentMessage(): Promise<
  ThrowableStatus<MostRecentMessageResponse>
> {
  try {
    const response = await fetch(`/api/getusermostrecentmessage`);
    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }
    const data: MostRecentMessageResponse = await response.json();
    return { isError: false, value: data };
  } catch (error) {
    return {
      isError: true,
      status: null,
      error: new Error(
        "There was an error with the '/api/getusermostrecentmessage' endpoint",
        { cause: error }
      ),
    };
  }
}
